export const convertSize = (size = 16) => ({
    height: size,
    width: size,
})
